import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { translationTypeOptions } from '@/module/Nomen/TranslationType/model/TranslationTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type TranslationTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function TranslationTypeSelectControl<T extends FieldValues>(props: TranslationTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(translationTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
